import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    * {
      font-family: ${({ theme }) => theme.fonts.primary};
    }
  }
`;
